import React from 'react';

const blocked = () => (
    <div className="alert alert-danger">
        Your account has been blocked for security reasons because you have unsuccessfully attempted to sign in a number of times that exceeds the maximum attempts allowed.
    </div>
);

export default blocked;